import { useTranslation } from "react-i18next";
import { ColorSpinner, ContentLoader, Text } from "shared/components/Spor";
import { SectionStateContentSize } from "shared/components/states/SectionStateContent";
import { StateContentContainer } from "shared/components/states/StateContentContainer";
import { useTheme } from "styled-components";

type LoadingProps = {
  backgroundColor?: string;
  size?: SectionStateContentSize;
};

const Content = ({ size }: { size: SectionStateContentSize }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (size === "sm") {
    return (
      <>
        <ColorSpinner width="50px" />

        <Text variant="sm" my="auto" color={theme.colorTextSporDefault}>
          {t("Laster innhold")}
        </Text>
      </>
    );
  }

  if (size === "lg") {
    return (
      <>
        <ContentLoader width="150px" />
        <Text
          my={0}
          textAlign="center"
          variant="ml"
          color={theme.colorTextSporDefault}
        >
          {t("Laster innhold")}
        </Text>
      </>
    );
  }

  /* md */
  return (
    <>
      <ColorSpinner width="50px" />
      <Text
        my={0}
        textAlign="center"
        variant="sm"
        color={theme.colorTextSporDefault}
      >
        {t("Laster innhold")}
      </Text>
    </>
  );
};

export const LoadingContent = ({
  backgroundColor,
  size = "md",
}: LoadingProps) => (
  <StateContentContainer size={size} backgroundColor={backgroundColor}>
    <Content size={size} />
  </StateContentContainer>
);
